import * as React from 'react';

type ScenePlaceholderProps = {
    mainClass: string;
    children?: React.ReactNode;
};

export default class ScenePlaceholder extends React.PureComponent<ScenePlaceholderProps> {
    render() {
        const { mainClass, children } = this.props;
        return (
            <div className={mainClass}>
                <div className="scene">
                    <span className="cloud cloud--small-1" />
                    <span className="cloud cloud--small-2" />
                    <span className="cloud cloud--small-3" />
                    <span className="cloud cloud--medium-1" />
                    <span className="cloud cloud--medium-2" />
                    <span className="cloud cloud--large-1" />
                    <span className="cloud cloud--large-2" />
                    <img className="plane" src="/Images/plane.svg" alt="" />
                    <div className="scene-message">{children}</div>
                </div>
            </div>
        );
    }
}
